import axios from 'axios';
import {
    ITask
} from 'src/models';

export default {
    // 未处理的代办列表（待接收）
    getTodoTasks(): Promise<ITask[]> {
        return axios.get<ITask[]>(`/api/audits/todos`).then(res => {
            return res.data;
        });
    },

    // 接收代办
    receiveTasks(): Promise<any> {
        return axios.post<any>(`/api/audits/todos/check`).then(res => {
            return res.data;
        });
    }
}
